import { http } from '../../../api'

const support = {
  namespaced: true,
  state: {
    messageList: null
  },
  actions: {

    getMessages: ({ commit }, params) => {
      let url = '/support'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setMessages', res.data.data)
        return res.data
      })
    },
    getMessageData: ({ commit }, id) => {
      return http.get('/support/' + id).then(res => {
        return res.data
      })
    },
    deleteItem: ({ commit }, id) => {
      return http.delete('/support/' + id).then(res => {
        commit('deleteBlog', id)
      })
    }
  },
  mutations: {
    setMessages (state, data) {
      state.messageList = data
    },
    deleteBlog (state, id) {
      state.messageList = state.messageList.filter(item => item.id !== id)
    }
  },
  getters: {
    messageList: state => state.messageList
  }
}

export default support
